import type { CSSProperties } from 'react';

/**
 * Play Together / WonderGuidance panel — typography & surface tokens.
 * Less-is-more; minimum readable size 16px; WG body 18px for comfortable reading.
 */

/** Full panel surface (header + body + tabs share this) */
export const WG_PANEL_SURFACE = `
  radial-gradient(circle at 10% 20%, rgba(134, 239, 172, 0.08) 0%, transparent 32%),
  radial-gradient(circle at 90% 80%, rgba(147, 197, 253, 0.08) 0%, transparent 32%),
  #FFFEF9
`;

export const WG_TEXT = {
  primary: '#111827',
  secondary: '#374151',
  muted: '#4B5563',
} as const;

/** Title / subtitle: requested 58px / 38px — clamp so narrow panels still fit */
export const wgHeaderTitleStyle: CSSProperties = {
  fontFamily: "'Nunito', sans-serif",
  fontSize: 'clamp(32px, 6vw, 58px)',
  lineHeight: 1.08,
  fontWeight: 800,
  color: '#42a57a',
  margin: 0,
  letterSpacing: '-0.02em',
};

export const wgHeaderSubtitleStyle: CSSProperties = {
  fontFamily: "'Nunito', sans-serif",
  fontSize: 'clamp(18px, 3.5vw, 38px)',
  lineHeight: 1.2,
  fontWeight: 600,
  color: WG_TEXT.secondary,
  margin: 0,
  marginTop: '0.35em',
};

/** WonderGuidance conversation body (bubbles, empty state, onboarding) */
export const wgBodyStyle: CSSProperties = {
  fontFamily: "'Nunito', sans-serif",
  fontSize: '18px',
  lineHeight: 1.65,
};

/** UI chrome: buttons, chips, input — never below 16px */
export const wgChromeMin = '16px' as const;
